// Import all views here
import advancedView from './views/advanced';
import homeView from './views/home';
import faqView from './views/faq';
import educationView from './views/education';
import insightsView from './views/insights';
import aboutView from './views/about';
import formView from './views/form';
import coursesView from './views/courses';
import courseView from './views/course';
import servicesView from './views/services';
import teamView from './views/team';
import blogsView from './views/blogs';
import publicationsView from './views/publications';
import blogItemView from './views/blog';
import publicationItemView from './views/publication';
import speakerView from './views/speaker';
import contactView from './views/contact';

export default [
	advancedView,
	faqView,
	educationView,
	insightsView,
	aboutView,
	homeView,
	coursesView,
	servicesView,
	formView,
	teamView,
	blogsView,
	publicationsView,
	blogItemView,
	publicationItemView,
	speakerView,
	courseView,
	contactView,
];
